export default __webpack_public_path__ + "static/media/logo-white.3847d3bc.png";